import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { HiOutlineDocumentArrowDown } from 'react-icons/hi2';
import CustomDatePicker from '../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import CheckboxMultiSelect from '../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import { MPSwitch } from '../../../../../../components/ui';

export interface FilterOption {
  value: any;
  label: string;
}

interface FilterBarProps {
  startDate: string;
  endDate: string;
  setStartDate: (date: string) => void;
  setEndDate: (date: string) => void;
  soloSesionActual: boolean;
  setSoloSesionActual: (value: boolean) => void;
  userOptions: FilterOption[];
  selectedUsers: FilterOption[];
  onUsersChange: (users: FilterOption[]) => void;
  mesaOptions: FilterOption[];
  selectedMesas: FilterOption[];
  onMesasChange: (mesas: FilterOption[]) => void;
  onExportToExcel?: () => void;
  exportDisabled?: boolean;
  totalModifications?: number;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  soloSesionActual,
  setSoloSesionActual,
  userOptions,
  selectedUsers,
  onUsersChange,
  mesaOptions,
  selectedMesas,
  onMesasChange,
  onExportToExcel,
  exportDisabled = false,
  totalModifications = 0,
  searchValue = '',
  onSearchChange,
}) => {
  const handleStartDateChange = (date: string) => {
    setStartDate(date);
    setSoloSesionActual(false);
  };

  const handleEndDateChange = (date: string) => {
    setEndDate(date);
    setSoloSesionActual(false);
  };

  return (
    <div className="mp-toolbar">
      {/* Row 1: Search + Dates + Session toggle + Export */}
      <div className="flex flex-wrap items-center gap-2 lg:gap-3">
        {onSearchChange && (
          <div className="relative flex-1 min-w-[180px] max-w-[380px]">
            <FaSearch
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              size={13}
            />
            <input
              type="text"
              placeholder="Buscar modificaciones..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="mp-form-input w-full"
              style={{ paddingLeft: '2rem' }}
            />
          </div>
        )}

        <CustomDatePicker
          value={startDate}
          onChange={handleStartDateChange}
          disabled={soloSesionActual}
          placeholder="Desde"
        />
        <CustomDatePicker
          value={endDate}
          onChange={handleEndDateChange}
          disabled={soloSesionActual}
          placeholder="Hasta"
        />

        <MPSwitch
          label="Sesión actual"
          checked={soloSesionActual}
          onChange={(checked) => setSoloSesionActual(checked)}
        />

        {onExportToExcel && (
          <button
            className="mp-btn-export ml-auto"
            onClick={onExportToExcel}
            disabled={exportDisabled || totalModifications === 0}
            title="Exportar a Excel"
          >
            <HiOutlineDocumentArrowDown size={16} />
            Excel
          </button>
        )}
      </div>

      {/* Row 2: Filter dropdowns */}
      <div
        className="flex items-center gap-2 flex-wrap mt-3 pt-3"
        style={{ borderTop: '1px solid var(--border-color)' }}
      >
        <span className="text-xs font-semibold uppercase tracking-wider opacity-35 mr-1">
          Filtrar:
        </span>
        <div className="min-w-[130px]">
          <CheckboxMultiSelect
            options={userOptions}
            value={selectedUsers}
            onChange={onUsersChange}
            placeholder="Usuarios"
          />
        </div>
        <div className="min-w-[110px]">
          <CheckboxMultiSelect
            options={mesaOptions}
            value={selectedMesas}
            onChange={onMesasChange}
            placeholder="Mesas"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
